import React, { useEffect, useCallback } from "react"
import { toast } from "react-toastify"
import useAuthAxios from "../../hooks/useAuthAxios"
const EExpertView = ({
  repairId,
  onClose,
  appLookups,
  sessionId,
  onFileUpload,
  refreshRepairDetails,
  isDynamic,
  setLoading
}) => {
  const { post } = useAuthAxios()

  // Create different links for operator and user
  const operatorLink = `${process.env.REACT_APP_APP_URL}/operator/${repairId}/${sessionId}`

  const handleCompletion = useCallback(async () => {
    onClose() // Close the eExpert component
    setLoading(true)
    try {
      // Add history entry for completion
      await post(`/repairs/${repairId}/history`, {
        Descr: "Ολοκλήρωση διαδικασίας ExpertCall."
      })

      toast.success("Η διαδικασία ExpertCall ολοκληρώθηκε επιτυχώς")
      refreshRepairDetails()
    } catch (err) {
      console.error("Error completing e-expert process:", err)
      toast.error("Αποτυχία ολοκλήρωσης διαδικασίας ExpertCall")
      setLoading(false)
    }
  }, [post, repairId, onClose, refreshRepairDetails, setLoading])

  useEffect(() => {
    const handleMessage = async event => {
      // Verify the origin matches our expected app URL
      if (!event.origin.startsWith(process.env.REACT_APP_APP_URL)) {
        return
      }

      const { type, data } = event.data

      switch (type) {
        case "REQUEST_FILE_TYPES":
          // Send file types to the iframe
          const fileTypes = appLookups?.filter(lookup => lookup.Table === "FilesKind") || []
          event.source.postMessage(
            {
              type: "FILE_TYPES",
              data: fileTypes
            },
            event.origin
          )
          break

        case "UPLOAD_FILE":
          // Handle file upload using the passed function
          const response = await onFileUpload(data, true)
          // Create response data by excluding fileContent and adding success status
          const responseData = { ...data }
          delete responseData.fileContent
          responseData.success = response.success && response.data.IsSuccess
          event.source.postMessage(
            {
              type: "UPLOAD_RESPONSE",
              data: responseData
            },
            event.origin
          )
          break

        case "COMPLETE_SESSION":
          window.removeEventListener("message", handleMessage)
          // Handle session completion
          handleCompletion()
          break

        case "CANCEL_SESSION":
          window.removeEventListener("message", handleMessage)
          // Handle session cancellation
          handleCompletion()
          break

        default:
          console.warn("Unknown message type:", type)
      }
    }

    window.addEventListener("message", handleMessage)
    return () => window.removeEventListener("message", handleMessage)
  }, [onFileUpload, handleCompletion, appLookups, onClose])

  return (
    <div className="h-100">
      <iframe
        src={operatorLink + (isDynamic ? `?dynamic=${isDynamic}` : "")}
        title="E-expert App"
        className="w-100 h-100 border-0"
        allow="camera; microphone"
      />
    </div>
  )
}

export default EExpertView
